module.exports = __webpack_public_path__ + "f6b060d951bf95a2212cb3c9597c5067.png";